import React from 'react';
import ReactDOM from 'react-dom';

import Iconset from './icons';
import Clipboard from 'clipboard';

//styles
import '../styles/share.scss';

class Warenkorb extends React.Component{

	constructor(props){
		super(props);

		this.state={
			activeMenu : false,
		}

		this.copyButton = null;
		this.clipBoard = null;

		this.toggleShareMenu = this.toggleShareMenu.bind(this);
	}

	toggleShareMenu(){
		this.setState({
			activeMenu : !this.state.activeMenu
		});
	}


	componentDidMount(){

	}

	render(){
		return (
			<div className="flex-box share-holder warenkorb">
				<button className="share-button" onClick={ this.toggleShareMenu }>
					<Iconset.warenkorbIcon/>
				</button>
				<div className={"share-menu share-menu-" + this.state.activeMenu} >
					<div className="share-icon-set">
						<div className="share-icon">
							<a href="http://smarturl.it/Blossom_AM" target="_blank" data-name="Apple"><Iconset.appleHolo /></a>
						</div>
						<div className="share-icon">
							<a href="http://w.universal-music.de/save/campaign?campaign_id=7" target="_blank" data-name="Spotify"><Iconset.spotifyHolo /></a>
						</div>
						<div className="share-icon">
							<a href="http://smarturl.it/Blossom_IT" target="_blank" data-name="iTunes"><Iconset.itunesHolo /></a>
						</div>
						<div className="share-icon">
							<a href="http://smarturl.it/Blossom_AMZ" target="_blank" data-name="Amazon"><Iconset.amazonHolo /></a>
						</div>
					</div>
				</div>
			</div>);
	}
}

export default Warenkorb;


// WEBPACK FOOTER //
// ./src/scripts/warenkorb_menu.js